import { head, isEmpty } from 'lodash';
import moment from 'moment-timezone';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';

export const getYesterdayStock = (entityStock, storeTimezone) =>
  !isEmpty(entityStock)
    ? head(
        entityStock.filter(
          ({ date }) =>
            moment.tz(date, storeTimezone).format(DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR) ===
            moment
              .tz(storeTimezone)
              .subtract(1, 'days')
              .format(DATE_DISPLAY_FORMATS.SLASHED_DAY_MONTH_YEAR),
        ),
      )
    : {};

export const getNoInventoryMoreThanThirtyDays = (entityStock) =>
  !!entityStock
    ? !entityStock.some(
        ({ realStockUnit, inventoryListId }) => realStockUnit != null || !!inventoryListId,
      )
    : false;
